// GAME_STATE =================================================================

export const COMMAND_BOX_FLAG = {
    FIGHT: 'fight',
    MOVE: 'move',
    NONE: 'none'
};

export const GAME_STATE = {
    ONGOING: 'ongoing',
    FIGHT: 'fight',
    GAME_OVER: 'game over',
    VICTORY: 'victory',
    MODAL: 'modal'
}

// ZONES ======================================================================

// Tile variants for assembling more interesting maps. Add carefully — every
// new entry needs a matching tile in TILES_DATA inside Helpers/maps.js, and
// any zone in MAPS.<map>.zones can reference one of these for its `zoneType`.
export const ZONE_TYPES = {
    PLAIN: 'plain',
    FOREST: 'forest',
    WATER: 'water',
    CITY: 'city',
    ROAD: 'road',
    WOOD: 'wood',
    WATER_LEFT: 'water_left',
    WATER_RIGHT: 'water_right',
    WATER_UP: 'water_up',
    WATER_DOWN: 'water_down',
    WATER_CORNER_LEFT: 'water_corner_left',
    WATER_CORNER_RIGHT: 'water_corner_right',
    WATER_CORNER_UP: 'water_corner_up',
    WATER_CORNER_DOWN: 'water_corner_down',
    HUT_UP_PART: 'hut_up_part',
    HUT_DOWN_PART: 'hut_down_part',
}

// ITEMS ======================================================================

export const EFFECT_TYPE = {
    GAIN: {
        HP: 'gain HP',
        MP: 'gain MP',
        HP_MP: 'gain HP MP',
    }
}

export const ITEM_TYPE = {
    POTION: 'potion',
    WEAPON: 'weapon',
    ARMOR: 'armor',
    HELM: 'helm',
    ACCESSORY: 'accessory',
}

// Equipment slots — keys of state.hero.equipment.
// One slot type per ITEM_TYPE (excluding POTION).
export const EQUIPMENT_SLOT = {
    WEAPON: 'weapon',
    ARMOR: 'armor',
    HELM: 'helm',
    ACCESSORY: 'accessory',
}

// Maps an equipable item's type to the slot it occupies.
export const ITEM_TYPE_TO_SLOT = {
    [ITEM_TYPE.WEAPON]: EQUIPMENT_SLOT.WEAPON,
    [ITEM_TYPE.ARMOR]: EQUIPMENT_SLOT.ARMOR,
    [ITEM_TYPE.HELM]: EQUIPMENT_SLOT.HELM,
    [ITEM_TYPE.ACCESSORY]: EQUIPMENT_SLOT.ACCESSORY,
}

// MODAL ======================================================================

export const MODAL_FLAG = {
    INVENTORY: 'inventory',
    SHOP: 'shop',
    EVENT: 'event',
    NONE: 'none'
}

// SPRITE =====================================================================

export const SPRITE_FILTER = {
    DAY: 'brightness(1)',
    NIGHT: 'brightness(0.35)'
}

// EVENTS =====================================================================

export const SCRIPT_ACTION_TYPE = {
    GIVE_GOLD: 'giveGold',
    START_FIGHT: 'startFight',
    TAKE_ITEM: 'takeItem',
    END_EVENT: 'endEvent',
}

const SCRIPT_SPEAKER = {
    img: null,
    name: null,
}

const SCRIPT_ACTION = {
    type: SCRIPT_ACTION_TYPE,
    speaker: SCRIPT_SPEAKER, // Optional
    message: null, // Optional
    label: null,
    extraData: null, // Optional
    nextScriptId: null, // Optional
}

const EVENT_SCRIPT = {
    speaker: SCRIPT_SPEAKER, // Optional
    message: null, // Optional
    actions: [
        SCRIPT_ACTION,
        // {
        //     nextScriptId: '3',
        // }
    ]
}

const EVENT = {
    event1: {
        id: 'event1',
        scriptId: 'start',
        defaultSpeaker: SCRIPT_SPEAKER, // Optional
        defaultMessage: null, // Optional
        scripts: {
            // Exemples
            'start': EVENT_SCRIPT, // Obligatoire
            '1': {},
            '2': {},
            'unNom': {},
            'end': {}, 
            // Scripts par defaut pour action startFight
            'endFightDead': {}, // En fin de combat -> joueur mort
            'endFightEscape': {}, // En fin de combat -> joueur a fuit
            'endFightDeadVictory': {}, // En fin de combat -> joueur vainqueur
            // Scripts par défaut pour action takeObject
            'inventoryFull': {}, // L'inventaire du joueur est plein au moment de recevoir les items
            // Scripts par défaut pour action giveGold
            'noGold': {} // Le joueur a 0 gold
        }
    }
}

export const EVENTS = {
    event1: {
        id: 'event1',
        scriptId: 'start',
        defaultSpeaker: {
            img: "/assets/monsters/monster_1.png",
            name: "Bruno",
        },
        defaultMessage: "Oh tu sors d'une boutique tu dois être blindé de fric, et si tu me donnais une pièce ?",
        scripts: {
            'start': {
                actions: [
                    {
                        type: SCRIPT_ACTION_TYPE.GIVE_GOLD,
                        label: "Tiens boloss, une pièce",
                        nextScriptId: 'end',
                        extraData: 20,
                    },
                    {
                        type: SCRIPT_ACTION_TYPE.START_FIGHT,
                        label: "Dégage d'ici",
                        extraData: ['monster3'],
                    }
                ]
            },
            'end': {
                message: "Ouais, t'avais plutôt interêt !",
                actions: [
                    {
                        type: SCRIPT_ACTION_TYPE.END_EVENT,
                        label: '*part*',
                    }
                ]
            },
            'endFightEscape' : {
                message: 'Donne ton fric !',
                actions: [
                    {
                        type: SCRIPT_ACTION_TYPE.GIVE_GOLD,
                        extraData: 60,
                        nextScriptId: 'endLoseFight',
                        label: "L'enfoiré..."
                    }
                ]
            },
            'endLoseFight': {
                message: 'Merci tocard',
                actions: [
                    {
                        type: SCRIPT_ACTION_TYPE.END_EVENT,
                        label: "..."
                    }
                ]
            }
        }
    },
    event2: {
        id: 'event2',
        scriptId: 'start',
        // defaultSpeaker: {
        //     name: "u$u",
        //     img: "https://www.beecom-digital.com/img/ccidex/Rowven3.png",
        // },
        // defaultMessage: "Comme tié beau mon gaté, tiens je te donne un élixir",
        scripts: {
            'start': {
                speaker: {
                    name: "u$u",
                    img: "/assets/monsters/monster_1.png",
                },
                message: "Comme tié beau mon gaté, tiens je te donne un élixir",
                actions: [
                    {
                        type: SCRIPT_ACTION_TYPE.TAKE_ITEM,
                        label: "*le prendre*",
                        extraData: [
                            ['potionSmallHP', 1]
                        ],
                        nextScriptId: "end",
                    },
                    {
                        type: SCRIPT_ACTION_TYPE.END_EVENT,
                        label: "Je refuse, je suis une femme indépendante, woman power, WAKANDA",
                    }
                ]
            },
            'end': {
                message: "Bonne décision, t'en aura besoin tapette",
                actions: [
                    {
                        type: SCRIPT_ACTION_TYPE.END_EVENT,
                        label: 'Ok à plus tocard et merci',
                    }
                ]
            },
        }
    },
    // event: EVENT
}

// STATS ======================================================================

export const STATS_UPDATE_TYPE = {
    INCREMENT: 'increment',
    DECREMENT: 'decrement'
}